import {usePaginatedViewVariablesContext} from '../context/paginated-view-variables'

export const usePaginatedMemexItemsQueryVariables = () => {
  const context = usePaginatedViewVariablesContext()
  if (!context) {
    throw new Error('usePaginatedMemexItemsQueryVariables must be used within a PaginatedViewVariablesProvider')
  }
  return context.variables
}
